import React from 'react';

import { getTimezones, Timezone } from '../../utils/timezone/service';
import { useContent } from '../../branding/content.context';

interface Props {
    timezoneId: string;
    onChange: (timezone: Timezone) => void;
}
export function TimezonePicker({ timezoneId, onChange }: Props) {
    const { scheduler: LANG } = useContent();
    const timezonesList = getTimezones();

    return (
        <>
            <label htmlFor="timezoneId">{LANG.timezoneLbl}: </label>
            <select
                id="timezoneId"
                value={timezoneId}
                onChange={(evt) => {
                    onChange({ tzid: evt.target.value, country: timezonesList[evt.target.value] });
                }}
            >
                {Object.keys(timezonesList).map((tzid) => (
                    <option key={tzid} value={tzid}>
                        {timezonesList[tzid]}
                    </option>
                ))}
            </select>
        </>
    );
}
